import React, { useEffect, useState } from 'react'
import ReactStars from "react-rating-stars-component";
import {Swiper, SwiperSlide} from 'swiper/react';
import {apiConnector} from "../../services/apiconnector";
import {ratingsEndpoints} from "../../services/apis"

import "swiper/css"
import "swiper/css/free-mode"
import "swiper/css/pagination"
import { Autoplay, FreeMode, Pagination } from "swiper/modules"
import { FaStar } from 'react-icons/fa';

const ReviewSlider = () => {

    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        const getReviewsData = async()=>{
            setLoading(true);
            const {data} = await apiConnector("GET", ratingsEndpoints.REVIEWS_DETAILS_API);
            if(data.success){
                setReviews(data.data);
            }
            setLoading(false);
        }
        getReviewsData();
    }, []);

    if(loading){
        return(
            <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
                <div className="spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        )
    }

    return (
        <div className='text-white'>
            <div className="my-[50px] h-[184px] max-w-maxContentTab lg:max-w-maxContent">
                <Swiper
                    modules={[FreeMode, Pagination, Autoplay]}
                    spaceBetween={25}
                    freeMode={true}
                    loop={true}
                    breakpoints={{
                        1024: {
                            slidesPerView: 4,
                        },
                    }}
                    slidesPerView={1}
                    autoplay={{
                        delay: 1700,
                        disableOnInteraction: false,
                    }}
                    className="w-full"
                >
                    {
                        reviews?.map((review, i)=>(
                            <SwiperSlide key={i}>
                                <div className="flex flex-col gap-3 bg-richblack-800 p-3 text-[14px] text-richblack-25">
                                    <div className="flex items-center gap-4">
                                        <img src={review.user.image} alt="user_profile" className="h-9 w-9 rounded-full object-cover" />
                                        <div className="flex flex-col">
                                            <h1 className="font-semibold text-richblack-5">{`${review?.user?.firstName} ${review?.user?.lastName}`}</h1>
                                            <h2 className="text-[12px] font-medium text-richblack-500"> {review?.course?.courseName}</h2>
                                        </div>
                                    </div>
                                    <p className="font-medium text-richblack-25 h-[63px] overflow-hidden">
                                        {
                                            review?.review.split(" ").length > 25 
                                            ? `${review?.review.split(" ").slice(0, 25).join(" ")} ...` 
                                            : `${review?.review}`
                                        }
                                    </p>
                                    <div className="flex items-center gap-2">
                                        <h3 className="font-semibold text-yellow-100">{review.rating.toFixed(1)}</h3>
                                        <ReactStars 
                                            value={review.rating} 
                                            edit={false} count={5} size={20} activeColor={"#ffd700"} 
                                            emptyIcon={<FaStar/>} 
                                            fullIcon={<FaStar/>} 
                                        />
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
            </div>
        </div>
    )
}

export default ReviewSlider
